import { Component } from '@angular/core';
import Swal from 'sweetalert2';
import { Subject, takeUntil } from 'rxjs';
import { IPregnancyOutcomeDetailed } from '../../../../../../interfaces/PregnancyOutcome/IPregnancyOutcomeDetailed';
import { PregnancyOutcomeAddEditComponent } from '../pregnancy-outcome/pregnancy-outcome-add-edit/pregnancy-outcome-add-edit.component';
import { PregnancyOutcomeService } from 'src/app/services/pregnancyOutcome.service';
import { TranslateService } from '@ngx-translate/core';
import { COLORS } from 'src/styles/colors';
import { SwalToastService } from 'src/app/services/swal.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-pregnancy-outcome',
    templateUrl: './pregnancy-outcome.component.html',
    styleUrls: ['./pregnancy-outcome.component.css'],
    standalone: false
})
export class PregnancyOutcomeComponent {
  public addComp = PregnancyOutcomeAddEditComponent;
  // public expandComp = PregnancyOutcomeExpandComponent;

  private destroy$ = new Subject<void>();

  pregnancyOutcome?: IPregnancyOutcomeDetailed[];
  isLoading: boolean = false;

  constructor(
    private readonly pregnancyOutcomeService: PregnancyOutcomeService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
    private readonly permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.pregnancyOutcomeService.pregnancyOutcomeLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.pregnancyOutcomeService.pregnancyOutcomeDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IPregnancyOutcomeDetailed[]) => {
        this.pregnancyOutcome = data;
      });

    this.pregnancyOutcomeService.getData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  openModalFun(item?: IPregnancyOutcomeDetailed) {
    this.pregnancyOutcomeService.pregnancyOutcomeModalSub.next(true);
    this.pregnancyOutcomeService.pregnancyOutcomeEditSub.next(item);
  }

  deleteFun(pregnancyOutcomeId: number) {
    Swal.fire({
      text: `${this.translate.instant(
        'deletePlaceholder1'
      )} ${this.translate.instant('Pregnancy Outcome')}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: `${this.translate.instant('Cancel')}`,
      confirmButtonText: `${this.translate.instant('Ok')}`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.pregnancyOutcomeService
          .deletePregnancyOutcome(pregnancyOutcomeId.toString())
          .subscribe({
            next: (d) => {
              this.swalToastService.toastSuccess(
                'Pregnancy Outcome deleted successfully'
              );
              this.pregnancyOutcomeService.deletePregnancyOutcomeFromTable(
                pregnancyOutcomeId.toString()
              );
            },
            error: (err) => {
              this.swalToastService.toastError(
                'Unable to delete Pregnancy Outcome'
              );
            },
          });
      } else if (result.isDenied) {
        Swal.fire(
          `${this.translate.instant('Pregnancy Outcome is not deleted')}`,
          '',
          'info'
        );
      }
    });
  }

  // expandSet = new Set<number>();
  // onExpandChange(id: number, checked: boolean): void {
  //   if (checked) {
  //     this.expandSet.add(id);
  //   } else {
  //     this.expandSet.delete(id);
  //   }
  // }
}
